export default class Preset {
    constructor(readonly name: string, readonly key: string, readonly widgetTypes: Array<string>) {}
}

export class AtomisablePreset {
    constructor(readonly name: string, readonly key: string) {}
}
